import create from "zustand";
import { persist } from "zustand/middleware";
import { mapStoreMethodToApiKey } from "utils/paymentOptions";

const normalize = (code) => code?.toLowerCase() === "zig" ? "ZWL" : code;
const store = (set, get) => ({
    currency: "USD",
    paymentMethod: "Ecocash USD",
    currencies: [],
    methods: {},
    setCatalog: (currencies) => {
        const selected = normalize(get().currency);
        set({ currencies, currency: currencies.some((c) => c.code === selected) ? selected : "USD" });
    },
    setMethods: (methods) => set({ methods }),
    setCurrency: (code) => set({ currency: normalize(code) }),
    setPaymentMethod: (method) => {
        const config = get().methods[mapStoreMethodToApiKey(method)];
        const supported = config?.supported_currencies || [];
        set({ paymentMethod: method });
        if (method && supported.length && !supported.includes(get().currency)) {
            const available = supported.find((code) => get().currencies.some((c) => c.code === code));
            if (available) set({ currency: available });
        }
    },
});
const useCurrencyStore = create(persist(store, {
    name: "zus-currency", getStorage: () => localStorage,
    partialize: ({ currency, paymentMethod }) => ({ currency, paymentMethod }),
}));
export default useCurrencyStore;
